module.exports = __webpack_public_path__ + "img/kredete.81fb0be2.png";